import { render, staticRenderFns } from "./gs-issu.vue?vue&type=template&id=594eb393"
import script from "./gs-issu.vue?vue&type=script&lang=ts"
export * from "./gs-issu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports